import Vue from "vue";

let els;

if ((els = document.querySelectorAll(".faqTwo")).length > 0) {
  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el,
      name: "FAQTwo",
      data() {
        return {
          cities: [],
          opened: false,
          selectedFaq: null,
          heights: {},
          colors: [
            "text-default-300",
            "text-default-500",
            "text-default-200",
            "text-default-400",
            "text-default-600",
          ],
          questions: window.passdata.template.faq.questions,
        };
      },
      methods: {
        answerHeight(question, index) {
          return this.opened === index ? "100%" : 0;
        },
        selectFaq(index) {
          if (this.selectedFaq === index) {
            this.selectedFaq = null;
          } else {
            this.selectedFaq = index;
          }
        },
      },
      mounted() {
        // this.$refs.answers.forEach((answer, index) => {
        //   this.heights[index] = answer.getBoundingClientRect().height;
        //   this.questions[index].init = true;
        // });
        // this.$nextTick(() => {
        //   this.opened = -1;
        // });
      },
    });
  }
}
